// extracted by mini-css-extract-plugin
export default {"button":"viewSwitchButton_button__OjFfa","active":"viewSwitchButton_active__pmEfe"};